import { ExternalLink } from '@qodana/blocks/lib/components/ExternalLink/ExternalLink'
import cn from 'classnames'

import { useConfig } from '../../../config/useConfig'

import styles from './DisplayComponentError.module.css'

type DisplayComponentErrorProps = {
	componentName: string
	className?: string
	border?: boolean
}

export function DisplayComponentError(props: DisplayComponentErrorProps) {
	const { border = false, componentName, className = '' } = props

	const appConfig = useConfig()

	const errorTemplate = (
		<>
			<span>Oops, we can’t show the {componentName.toLowerCase()}.</span>
			{!!appConfig.youtrackIssueTemplateUrl && (
				<span>
					You can try to report to us via{' '}
					<ExternalLink href={appConfig.youtrackIssueTemplateUrl}>YouTrack.</ExternalLink>
				</span>
			)}
		</>
	)

	return <div className={cn({ [styles.container]: border }, className)}>{errorTemplate}</div>
}
